import { useQuery } from '../lib/useQuery'
import CheckoutSuccess from '../components/CheckoutSuccess'
import { GetUnstableData } from '../graphql/docs'

export default function CheckoutSuccessPage() {
	const { data: unstableData, loading: dataLoading } = useQuery(GetUnstableData, {
		context: 'onboarding'
	})

	return (
		<>
			{dataLoading && <div>Loading...</div>}
			<CheckoutSuccess data={unstableData?.data} />
		</>
	)
}
